module.exports = __webpack_public_path__ + "img/okay.e95845db.png";